/*************************************************************************
 *
 * KLEAREXPRESS CONFIDENTIAL
 * __________________
 *
 *  Copyright (c) 2018 - 2018 KlearExpress Corporation.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of KlearExpress Corporation and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to KlearExpress Corporation
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from KlearExpress Corporation.
 */


import React, { Component } from 'react';
import './styles/css/terms-of-service.css';
import { Segment, Form, Header, Icon, } from 'semantic-ui-react';
import { Link} from 'react-router-dom';
import Images from '../media/tos/tos';
import TOS from './tos'

class ViewTerms extends Component {

	render() {
		return (
			<Segment padded='very' className="tos-form">
				<Form onSubmit={this.handleSubmit}>
					<div style={{display:'flex',justifyContent:'right'}} >
						<Link replace to='/' >
							<Icon name='delete' circular color='teal' corner='top right' />
						</Link>
					</div>
					<center>
						<Header className='tos-title' as='h1'>KLEARNOW Corp. Terms and conditions of service.</Header>
						<Header className='tos-title' as='h5'>UNITED STATES AND CANADA</Header>
						<Header className='tos-title' as='h5'>As of October 5th, 2018</Header>
					</center>
					<Form.Field>
						<div className="tosContainer">
							<TOS />
						</div>
					</Form.Field>

				</Form>
			</Segment>
		);
	}
}

export default ViewTerms;
